import CompleteProfile from './CompleteProfile';

export default CompleteProfile;
